
import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { UnauthenticatedOnlyRoute } from './RouteGuards';

// Import public pages
import Login from "@/pages/login";
import Signup from "@/pages/signup";
import Verify from "@/pages/verify";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import JoinPage from "@/pages/join";

import DeactivatedRoute from "@/pages/DeactivatedPage";

export function PublicRoutes() {
  const location = useLocation();
  
  console.log('[PublicRoutes] Current path:', location.pathname);
  
  try {
    return (
      <Routes>
        <Route
          path="/login"
          element={
            <UnauthenticatedOnlyRoute>
              <Login />
            </UnauthenticatedOnlyRoute>
          }
        />
        <Route
          path="/signup"
          element={
            <UnauthenticatedOnlyRoute>
              <Signup />
            </UnauthenticatedOnlyRoute>
          }
        />
        <Route 
          path="/verify" 
          element={<Verify />}
        />
        {/* Join page MUST stay public - no auth guards at all */}
        <Route
          path="/join"
          element={<JoinPage />}
        />
        <Route
          path="/forgot-password"
          element={<ForgotPassword />}
        />
        <Route
          path="/reset-password"
          element={<ResetPassword />}
        />
        <Route 
          path="/deactivated" 
          element={<DeactivatedRoute />}
        />
        <Route 
          path="/" 
          element={<Navigate to="/login" replace />}
        />
        <Route 
          path="*" 
          element={<Navigate to="/login" replace />}
        />
      </Routes>
    );
  } catch (error) {
    console.error('[PublicRoutes] Error rendering routes:', error);
    return (
      <div className="min-h-screen bg-red-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-xl font-bold text-red-600">Public Routes Error</h1>
          <p className="text-red-500">Check console for details</p>
        </div>
      </div>
    );
  }
}
